import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";

Vue.use(VueRouter);

// configure router
const router = new VueRouter({
  mode: "history",
  routes, // short for routes: routes
  linkActiveClass: "active"
});

router.beforeEach((to, from, next) => {
    const publicPages = ['/login', '/password-reset', '/reset-password'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.getItem('user');
    const myGroups = localStorage.getItem('groups');

    if (authRequired && !loggedIn) {
      return next('login')
    }
    next();
  }
)

export default router;
